// extracted by mini-css-extract-plugin
export var container = "style-module--container--9pfw7";
export var title = "style-module--title--XdCYk";
export var squareContainer = "style-module--squareContainer--3UKaO";
export var square = "style-module--square--BHfBS";
export var textSquareContainer = "style-module--textSquareContainer--4prJA";
export var logoContainer = "style-module--logoContainer--E2Od7";
export var logoWrapper = "style-module--logoWrapper--TT-6t";